import React from "react";
import "./Rules.css";

const Rule = () => {
  return (
    <div className="rule-container">
      <h2 className="rule-title">Sheria & Kanuni za Umakini</h2>

      {/* ================= UMUHIMU ================= */}
      <div className="rule-card">
        <h3 className="rule-subtitle">1. Umuhimu wa Umakini</h3>
        <p className="rule-text">
          <strong>AntBet FOOTBALL</strong> inahimiza watumiaji wote kucheza
          kwa umakini na uwajibikaji. Betting si njia ya kupata kipato
          cha uhakika bali ni burudani inayohitaji nidhamu.
        </p>
      </div>

      {/* ================= MFUMO WA REVERSE BETTING ================= */}
      <div className="rule-card">
        <h3 className="rule-subtitle">2. Mfumo wa Reverse Betting</h3>
        <p className="rule-text">
          AntBet FOOTBALL hutumia mfumo wa <strong>Reverse Betting</strong>,
          ambapo mtumiaji hubashiri matokeo <strong>yasiyotokea</strong>.
          Ushindi hupatikana pale matokeo uliyoyachagua
          <strong> hayajatokea</strong>, tofauti na betting ya kawaida.
        </p>
        <p className="rule-text">
          Mfumo huu unalenga kuwasaidia watumiaji kufanya maamuzi kwa
          uchambuzi na mantiki, si kubahatisha.
        </p>
      </div>

      {/* ================= UMRI ================= */}
      <div className="rule-card">
        <h3 className="rule-subtitle">3. Umri unaoruhusiwa</h3>
        <p className="rule-text">
          Mtumiaji lazima awe na umri wa <strong>miaka 18 au zaidi</strong>
          ili kutumia huduma za AntBet FOOTBALL.
        </p>
      </div>

      {/* ================= PESA ================= */}
      <div className="rule-card">
        <h3 className="rule-subtitle">4. Matumizi ya Pesa</h3>
        <ul className="rule-list">
          <li>✔ Cheza kwa pesa unayoweza kupoteza</li>
          <li>✔ Epuka kukopa au kuweka rehani mali zako</li>
          <li>✔ Weka bajeti yako kabla ya kucheza</li>
          <li>✔ Usitumie pesa za matumizi ya msingi</li>
        </ul>
      </div>

      {/* ================= UELIMU ================= */}
      <div className="rule-card">
        <h3 className="rule-subtitle">5. Elimu ya Betting</h3>
        <p className="rule-text">
          AntBet FOOTBALL inalenga kutoa elimu sahihi ya betting ili
          kuwasaidia vijana kucheza kwa uelewa, si kwa hisia.
        </p>
      </div>

      {/* ================= AKAUNTI ================= */}
      <div className="rule-card">
        <h3 className="rule-subtitle">6. Usalama wa Akaunti</h3>
        <ul className="rule-list">
          <li>✔ Akaunti moja kwa mtumiaji mmoja</li>
          <li>✔ Linda taarifa zako za siri</li>
          <li>✔ Usiruhusu mtu mwingine kutumia akaunti yako</li>
        </ul>
      </div>

      {/* ================= BONASI ================= */}
      <div className="rule-card">
        <h3 className="rule-subtitle">7. Bonasi & Zawadi</h3>
        <p className="rule-text">
          Bonasi zote hutolewa kwa masharti ya mfumo.
          AntBet FOOTBALL ina haki ya kusitisha bonasi
          endapo itabainika udanganyifu.
        </p>
      </div>

      {/* ================= SHERIA KUBWA ================= */}
      <div className="rule-card rule-danger">
        <h3 className="rule-subtitle">8. Sheria Kuu ya Nidhamu</h3>
        <p className="rule-text">
          Mtumiaji yeyote atakayebainika <strong>kusambaza uvumi,
          taarifa za uongo, kupotosha wanachama wengine, au kuchafua
          jina la AntBet FOOTBALL</strong> kwa njia yoyote ile
          atachukuliwa hatua kali.
        </p>
        <p className="rule-text">
          Hatua hizo zinaweza kujumuisha:
        </p>
        <ul className="rule-list">
          <li>❌ Kufungiwa akaunti mara moja</li>
          <li>❌ Kufukuzwa kabisa kwenye mfumo</li>
          <li>❌ Kuchukuliwa hatua za kisheria endapo itahitajika</li>
        </ul>
      </div>

      {/* ================= SHERIA YA VIONGOZI ================= */}
      <div className="rule-card rule-danger">
        <h3 className="rule-subtitle">9. Sheria kwa Viongozi & Vikundi</h3>
        <p className="rule-text">
          Endapo <strong>kiongozi wa kundi</strong> atahusika katika
          uvunjaji wa sheria, upotoshaji au uchochezi,
          <strong> yeye pamoja na wasaidizi wake wote
          watafukuzwa mara moja</strong> bila onyo.
        </p>
        <p className="rule-text">
          AntBet FOOTBALL haitavumilia vitendo vya makundi
          vinavyoharibu uaminifu wa mfumo.
        </p>
      </div>

      {/* ================= KUMBUKA ================= */}
      <div className="rule-card rule-warning">
        <h3 className="rule-subtitle">⚠ Kumbuka</h3>
        <p className="rule-text">
          Reverse betting bado ni betting. Cheza kwa akili,
          kwa mipaka na kwa malengo ya burudani.Ikiwa utatumia mpango wa viongozi wakundi fidia utapata asilimia 100%
        </p>
      </div>

      <div className="rule-footer">
        <p>© {new Date().getFullYear()} AntBet FOOTBALL</p>
        <p>Play Responsibly</p>
      </div>
    </div>
  );
};

export default Rule;